var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24"}},_vm.$listeners),[_c('path',{attrs:{"fill":"currentColor","d":"M20 18a1 1 0 0 1 .117 1.993L20 20H4a1 1 0 0 1-.117-1.993L4 18zm0-7a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0-7a1 1 0 1 1 0 2H4a1 1 0 0 1 0-2z"}})])
}
var staticRenderFns = []

export default { render: render }